import { useContext } from 'react';

import { AuthenticationClientContext } from '@dashboard/contexts/AuthenticationClientManager';

export default function useAdministratorClient() {
  const context = useContext(AuthenticationClientContext);
  if (context === null) {
    throw new Error('useAdministratorClient must be used within a PlatformManager');
  }
  return context.administratorClient;
}
